'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RouteModalRoot = require('./RouteModalRoot');

var _RouteModalRoot2 = _interopRequireDefault(_RouteModalRoot);

var _AuthenticatedContainer = require('../../auth/AuthenticatedContainer');

var _AuthenticatedContainer2 = _interopRequireDefault(_AuthenticatedContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var RouteModalRootAuthenticated = function RouteModalRootAuthenticated(props) {
    return _react2.default.createElement(
        _AuthenticatedContainer2.default,
        null,
        _react2.default.createElement(
            _RouteModalRoot2.default,
            props,
            props.children
        )
    );
};

RouteModalRootAuthenticated.propTypes = {
    children: _propTypes2.default.node
};

exports.default = RouteModalRootAuthenticated;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/RouteModalRootAuthenticated.js
// module id = 1920
// module chunks = 0